var map = {
	"./ENG.json": "./src/locales/ENG.json",
	"./KHM.json": "./src/locales/KHM.json",
	"./KOR.json": "./src/locales/KOR.json",
	"./MMR.json": "./src/locales/MMR.json",
	"./VNM.json": "./src/locales/VNM.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";